import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HTTP_INTERCEPTORS,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, concatMap, Observable, throwError } from 'rxjs';
import { LoginService } from '../login/login.service';
import { RefreshTokenReq } from 'src/app/models/user/login.model';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  refreshToken: RefreshTokenReq = {
    token: '',
  };

  constructor(private loginService: LoginService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!this.loginService.isLogin()) {
      return next.handle(request);
    }

    let authReq = request;
    const token = this.loginService.getToken();

    authReq = this.addToken(request, token);

    if (token != null) {
      authReq = authReq.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
    }

    // return next.handle(authReq);

    return next.handle(authReq).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status !== 200) {
          this.refreshToken.token = this.loginService.getToken();
          console.log(this.refreshToken);
          return this.loginService.refreshTokenService(this.refreshToken).pipe(
            concatMap((data: any) => {
              console.log('refreshing ...');
              this.loginService.setToken(data.token);
              authReq = this.addToken(request, data.token);
              return next.handle(authReq);
            })
          );
        } else {
          this.loginService.logout();
          return throwError(() => err);
        }
      })
    );
  }

  private addToken(req: HttpRequest<any>, token: any): HttpRequest<any> {
    return req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
  }
}

export const authInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true,
  },
];
